import React from 'react';
import { useTranslation } from 'react-i18next';
import '@/styles/ipe/workbench/Img2ImgPage.css';

const MODE_OPTIONS = ['basic', 'deep'];

export default function InfringementDetectionStepParams({ p, onChange, readOnly = false }) {
  const { t } = useTranslation('workbench');
  const mode = p.filterMode === 'deep' ? 'deep' : 'basic';
  const copy = {
    basic: { label: t('workflowParams.filterBasic'), hint: t('workflowParams.filterBasicHint') },
    deep: { label: t('workflowParams.filterDeep'), hint: t('workflowParams.filterDeepHint') },
  };
  const activeMode = copy[mode];

  return (
    <div className="img2img-page wf-studio-params-root wf-editor-infringement">
      <section className="img2img-studio__section" aria-label={t('workflowParams.filterMode')}>
        <div className="img2img-studio__field-row">
          <span className="img2img-studio__field-label">{t('workflowParams.filterMode')}</span>
          <span className="img2img-studio__field-hint">{activeMode.hint}</span>
        </div>
        <div className="img2img-studio__qty-row" role="group" aria-label={t('workflowParams.filterMode')}>
          {MODE_OPTIONS.map((value) => (
            <button
              key={value}
              type="button"
              className={`img2img-studio__qty-btn${mode === value ? ' is-active' : ''}`}
              onClick={() => onChange({ filterMode: value })}
              disabled={readOnly}
              aria-pressed={mode === value}
            >
              {copy[value].label}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
